// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-main[data-v-078753dd] {\n  min-height: calc(100% - 50px);\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  background: #fff;\n  padding: 16px;\n}\n.fixed-header+.app-main[data-v-078753dd] {\n  padding-top: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
